var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _path7, _path8, _path9, _path10, _path11, _path12, _rect4, _rect5, _path13, _path14, _path15, _path16, _path17, _path18, _rect6, _circle, _rect7, _path19, _rect8, _path20, _rect9, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersistenceConstrastShower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 144,
    viewBox: "0 0 283 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 34,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#57A1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7688 81.9991C49.7688 83.3586 48.6667 84.4606 47.3072 84.4606C45.9478 84.4606 44.8457 83.3586 44.8457 81.9991C44.8457 79.5376 47.3072 77.6914 47.3072 77.6914C47.3072 77.6914 49.7688 79.5376 49.7688 81.9991Z",
    fill: "#24284E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1535 81.9991C41.1535 83.3586 40.0515 84.4606 38.692 84.4606C37.3325 84.4606 36.2305 83.3586 36.2305 81.9991C36.2305 79.5376 38.692 77.6914 38.692 77.6914C38.692 77.6914 41.1535 79.5376 41.1535 81.9991Z",
    fill: "#24284E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2307 73.3839C36.2307 74.7433 35.1286 75.8454 33.7692 75.8454C32.4097 75.8454 31.3076 74.7433 31.3076 73.3839C31.3076 70.9223 33.7692 69.0762 33.7692 69.0762C33.7692 69.0762 36.2307 70.9223 36.2307 73.3839Z",
    fill: "#24284E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4612 73.3839C45.4612 74.7433 44.3591 75.8454 42.9996 75.8454C41.6402 75.8454 40.5381 74.7433 40.5381 73.3839C40.5381 70.9223 42.9996 69.0762 42.9996 69.0762C42.9996 69.0762 45.4612 70.9223 45.4612 73.3839Z",
    fill: "#24284E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6926 73.3839C54.6926 74.7433 53.5905 75.8454 52.2311 75.8454C50.8716 75.8454 49.7695 74.7433 49.7695 73.3839C49.7695 70.9223 52.2311 69.0762 52.2311 69.0762C52.2311 69.0762 54.6926 70.9223 54.6926 73.3839Z",
    fill: "#24284E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1878 64.7694C60.2356 65.4474 59.68 66.0003 59.0003 66.0003H27.0003C26.3206 66.0003 25.765 65.4474 25.8128 64.7694C26.444 55.8276 33.8979 48.7695 43.0003 48.7695C52.1027 48.7695 59.5566 55.8276 60.1878 64.7694Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5381,
    y: 46.3086,
    width: 4.92308,
    height: 4.92308,
    rx: 1.23077,
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 34,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#57A1F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.769 81.9991C145.769 83.3586 144.667 84.4606 143.307 84.4606C141.948 84.4606 140.846 83.3586 140.846 81.9991C140.846 79.5376 143.307 77.6914 143.307 77.6914C143.307 77.6914 145.769 79.5376 145.769 81.9991Z",
    fill: "#24284E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.154 81.9991C137.154 83.3586 136.051 84.4606 134.692 84.4606C133.333 84.4606 132.23 83.3586 132.23 81.9991C132.23 79.5376 134.692 77.6914 134.692 77.6914C134.692 77.6914 137.154 79.5376 137.154 81.9991Z",
    fill: "#24284E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.231 73.3839C132.231 74.7433 131.129 75.8454 129.769 75.8454C128.41 75.8454 127.308 74.7433 127.308 73.3839C127.308 70.9223 129.769 69.0762 129.769 69.0762C129.769 69.0762 132.231 70.9223 132.231 73.3839Z",
    fill: "#24284E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.461 73.3839C141.461 74.7433 140.359 75.8454 139 75.8454C137.64 75.8454 136.538 74.7433 136.538 73.3839C136.538 70.9223 139 69.0762 139 69.0762C139 69.0762 141.461 70.9223 141.461 73.3839Z",
    fill: "#24284E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.693 73.3839C150.693 74.7433 149.591 75.8454 148.231 75.8454C146.872 75.8454 145.77 74.7433 145.77 73.3839C145.77 70.9223 148.231 69.0762 148.231 69.0762C148.231 69.0762 150.693 70.9223 150.693 73.3839Z",
    fill: "#24284E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.188 64.7694C156.236 65.4474 155.68 66.0003 155 66.0003H123C122.321 66.0003 121.765 65.4474 121.813 64.7694C122.444 55.8276 129.898 48.7695 139 48.7695C148.103 48.7695 155.557 55.8276 156.188 64.7694Z",
    fill: "#24284E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 136.538,
    y: 46.3086,
    width: 4.92308,
    height: 4.92308,
    rx: 1.23077,
    fill: "#24284E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 26,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#57A1F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M243.461 85.9998C243.461 87.6992 242.084 89.0768 240.385 89.0768C238.685 89.0768 237.308 87.6992 237.308 85.9998C237.308 82.9229 240.385 80.6152 240.385 80.6152C240.385 80.6152 243.461 82.9229 243.461 85.9998Z",
    fill: "#24284E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.692 85.9998C232.692 87.6992 231.314 89.0768 229.615 89.0768C227.916 89.0768 226.538 87.6992 226.538 85.9998C226.538 82.9229 229.615 80.6152 229.615 80.6152C229.615 80.6152 232.692 82.9229 232.692 85.9998Z",
    fill: "#24284E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.539 75.2303C226.539 76.9297 225.161 78.3072 223.462 78.3072C221.762 78.3072 220.385 76.9297 220.385 75.2303C220.385 72.1534 223.462 69.8457 223.462 69.8457C223.462 69.8457 226.539 72.1534 226.539 75.2303Z",
    fill: "#24284E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.077 75.2303C238.077 76.9297 236.699 78.3072 235 78.3072C233.3 78.3072 231.923 76.9297 231.923 75.2303C231.923 72.1534 235 69.8457 235 69.8457C235 69.8457 238.077 72.1534 238.077 75.2303Z",
    fill: "#24284E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.616 75.2303C249.616 76.9297 248.238 78.3072 246.539 78.3072C244.839 78.3072 243.462 76.9297 243.462 75.2303C243.462 72.1534 246.539 69.8457 246.539 69.8457C246.539 69.8457 249.616 72.1534 249.616 75.2303Z",
    fill: "#24284E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M256.485 64.4607C256.545 65.3083 255.85 65.9994 255 65.9994H215C214.151 65.9994 213.456 65.3083 213.516 64.4607C214.305 53.2835 223.622 44.4609 235 44.4609C246.378 44.4609 255.696 53.2835 256.485 64.4607Z",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 231.923,
    y: 41.3848,
    width: 6.15385,
    height: 6.15385,
    rx: 1.53846,
    fill: "#24284E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 96L167.5 100L174.5 92",
    stroke: "#1E1B51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 96L71.5 100L78.5 92",
    stroke: "#1E1B51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 80,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 96,
    r: 2,
    fill: "#1E1B51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 257,
    cy: 96,
    r: 2,
    fill: "#1E1B51"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 273,
    cy: 96,
    r: 2,
    fill: "#1E1B51"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 14.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 15,
    r: 2,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 130,
    r: 2,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 142.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.5,
    cy: 114.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 122.5,
    r: 1.5,
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M281 10L272 21",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5 13L201 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M259 135L248.5 120.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceConstrastShower);
export default __webpack_public_path__ + "static/media/persistence-constrast-shower.a810e6594efd77b40d4b22c3cdb98215.svg";
export { ForwardRef as ReactComponent };